/* =====================================================================
   mobile-dots.js — dot pagination sync for the .objx mobile carousel
   ---------------------------------------------------------------------
   - Mobile only: the track only scrolls horizontally below 600px (CSS
     gates the layout). This script is a no-op cost on desktop because
     IntersectionObserver simply never reports cross-axis intersection
     changes when the cards are a static grid — but we also guard with a
     matchMedia check so we never bind work on desktop.
   - Tapping a dot scrolls its card into view (smooth, unless the user
     prefers reduced motion).
   - Scrolling/swiping updates the active dot via IntersectionObserver
     against the track as root.
   - Self-contained, no deps, idempotent, safe to load in <head defer>
     or at end of <body>.
   ===================================================================== */
(function () {
  "use strict";

  function init() {
    var track = document.querySelector(".objx__cards");
    var dotsWrap = document.querySelector(".mdot__dots");
    if (!track || !dotsWrap) return;

    var cards = Array.prototype.slice.call(
      track.querySelectorAll(".objx__card")
    );
    var dots = Array.prototype.slice.call(
      dotsWrap.querySelectorAll(".mdot__dot")
    );
    if (!cards.length || dots.length !== cards.length) return;

    var reduceMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;

    function setActive(index) {
      for (var i = 0; i < dots.length; i++) {
        var on = i === index;
        dots[i].classList.toggle("is-active", on);
        dots[i].setAttribute("aria-current", on ? "true" : "false");
      }
    }

    // Tap a dot -> bring its card into view.
    dots.forEach(function (dot, i) {
      dot.addEventListener("click", function () {
        var card = cards[i];
        if (!card) return;
        // scrollIntoView with inline:center keeps the snap centered.
        card.scrollIntoView({
          behavior: reduceMotion ? "auto" : "smooth",
          inline: "center",
          block: "nearest"
        });
        setActive(i); // optimistic; observer will confirm
      });
    });

    // Observe which card is most visible inside the track.
    if ("IntersectionObserver" in window) {
      var io = new IntersectionObserver(
        function (entries) {
          // pick the entry with the largest intersection ratio that is
          // actually intersecting; fall back to nearest.
          var best = null;
          for (var e = 0; e < entries.length; e++) {
            var entry = entries[e];
            if (!entry.isIntersecting) continue;
            if (!best || entry.intersectionRatio > best.intersectionRatio) {
              best = entry;
            }
          }
          if (best) {
            var idx = cards.indexOf(best.target);
            if (idx > -1) setActive(idx);
          }
        },
        {
          root: track,
          // 0.6 => a card is "active" once it dominates the viewport.
          threshold: [0.51, 0.6, 0.75]
        }
      );
      cards.forEach(function (card) {
        io.observe(card);
      });
    } else {
      // Fallback: scroll listener computing nearest-center card.
      var raf = null;
      track.addEventListener(
        "scroll",
        function () {
          if (raf) return;
          raf = window.requestAnimationFrame(function () {
            raf = null;
            var center = track.scrollLeft + track.clientWidth / 2;
            var nearest = 0;
            var nearestDist = Infinity;
            for (var i = 0; i < cards.length; i++) {
              var c = cards[i];
              var cCenter = c.offsetLeft + c.offsetWidth / 2;
              var d = Math.abs(cCenter - center);
              if (d < nearestDist) {
                nearestDist = d;
                nearest = i;
              }
            }
            setActive(nearest);
          });
        },
        { passive: true }
      );
    }

    // Initialise active state.
    setActive(0);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
